import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=126af48b&scoped=true&"
import script from "./Heart.vue?vue&type=script&lang=js&"
export * from "./Heart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126af48b",
  null
  
)

export default component.exports